import React from 'react'
import styled from 'styled-components';
const NewsletterStyle = styled.div`
    width: 100%;
    height: 100%; 
    padding-top:150px;
 form.signupform.main-sign-frm {
    background: transparent;
    border-radius: 6px;
    padding:0;
    margin: 0 auto;

    @media only screen and (max-width: 768px) {
        width: calc(100% - 30px);
    }

    .signup-news {
        height: 100%;
        iframe {
            height: 845px;
        }
          } 
}   
`;
const NewsLetterForm = () => {
    return (
        <>
            <NewsletterStyle>
                <form className="signupform main-sign-frm" >
                    <div className='signup-news'>
                        <iframe
                            src="https://link.goagency.com/widget/form/Pe7Jn3SaTB7jf6KU61uN"
                            style={{ width: "100%", border: "none", borderRadius: "4px" }}
                            id="inline-Pe7Jn3SaTB7jf6KU61uN"
                            data-layout="{'id':'INLINE'}"
                            data-trigger-type="alwaysShow"
                            data-trigger-value=""
                            data-activation-type="alwaysActivated"
                            data-activation-value=""
                            data-deactivation-type="neverDeactivate"
                            data-deactivation-value=""
                            data-form-name="Newsletter Sign Up"
                            data-height="614"
                            data-layout-iframe-id="inline-Pe7Jn3SaTB7jf6KU61uN"
                            data-form-id="Pe7Jn3SaTB7jf6KU61uN"
                            title="Newsletter Sign Up"
                        >
                        </iframe>
                        <script src="https://link.goagency.com/js/form_embed.js"></script>
                    </div>
                </form>
            </NewsletterStyle >
        </>
    )
}

export default NewsLetterForm;